/* esm.sh - performance-now@2.1.0 */
import "/node/process.mjs";
export * from "/*performance-now@2.1.0/esnext/performance-now.mjs";
export { default } from "/*performance-now@2.1.0/esnext/performance-now.mjs";
